<template>
  <div>
    <b-card-group deck>
      <b-card class='mb-4 bg-primary-4 stat' title="Sent">
        <h3>{{email.sent}}</h3>
      </b-card>

      <b-card class='mb-4 p-2 bg-primary-5 stat' title="Open rate">
        <h3>{{open_rate}}%</h3>
      </b-card>

      <b-card class='mb-4 p-2 bg-primary-1 stat' title="Play rate">
        <h3>{{played_rate}}%</h3>
      </b-card>

      <b-card class='mb-4 p-2 bg-primary-1 stat' title="Click rate">
        <h3>{{click_rate}}%</h3>
      </b-card>

      <b-card class='mb-4 p-2 bg-primary-2 stat' title="Reply rate">
        <h3>{{reply_rate}}%</h3>
      </b-card>

      <b-card class='mb-4 p-2 bg-primary-3 stat' title="Bounce rate">
        <h3>{{bounce_rate}}%</h3>
      </b-card>

      <b-card class='mb-4 p-2 bg-primary-3 stat' title="Unsubscribe rate">
        <h3>{{unsubscribe_rate}}%</h3>
      </b-card>

      <b-card class='mb-4 p-2 bg-primary-3 stat' title="Auto reply rate">
        <h3>{{auto_reply_rate}}%</h3>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
export default {
  name: 'EmailAnalytics',
  props: ['email'],
  computed: {
    open_rate() {
      if (!this.email.sent) {return 0}
      return ((this.email.opened || 0) / this.email.sent * 100).toFixed(1)
    },
    played_rate() {
      if (!this.email.sent) {return 0}
      return ((this.email.played || 0) / this.email.sent * 100).toFixed(1)
    },
    click_rate() {
      if (!this.email.sent) {return 0}
      return ((this.email.clicked || 0) / this.email.sent * 100).toFixed(1)
    },
    reply_rate() {
      if (!this.email.sent) {return 0}
      return ((this.email.replied || 0) / this.email.sent * 100).toFixed(1)
    },
    bounce_rate() {
      if (!this.email.sent) {return 0}
      return ((this.email.bounced || 0) / this.email.sent * 100).toFixed(1)
    },
    unsubscribe_rate() {
      if (!this.email.sent) {return 0}
      return ((this.email.unsubscribed || 0) / this.email.sent * 100).toFixed(1)
    },
    auto_reply_rate() {
      if (!this.email.sent) {return 0}
      return ((this.email.auto_replied || 0) / this.email.sent * 100).toFixed(1)
    },
  }
}
</script>

<style>

</style>
